/**
 * Точка входа специально для UMD-сборки.
 * Она импортирует все необходимые части и экспортирует их
 * как единый объект по умолчанию.
 */
import { CSElement as MainElement } from './core/CSElement';
import { MemoryStorageAdapter as MemAdapter } from './persistence/MemoryStorageAdapter';
import { IndexedDBAdapter as IndexedDB } from './persistence/IndexedDBAdapter';
import { LocalForageAdapter as LocalForage } from './persistence/LocalForageAdapter';
import * as allInterfaces from './types/interfaces';

// и так далее для всех других экспортов, которые нужны в UMD...

export default {
  CSElement: MainElement,
  MemoryStorageAdapter: MemAdapter,
  IndexedDBAdapter: IndexedDB,
  LocalForageAdapter: LocalForage,
  interfaces: allInterfaces,
}; 